(function(){
var d=document,rm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
var h=d.querySelector('.hdr');
function sc(){if(h)h.classList.toggle('sc',window.scrollY>20)}
window.addEventListener('scroll',sc,{passive:true});sc();
function count(n){if(n._d)return;n._d=1;var to=+n.getAttribute('data-count'),s=n.getAttribute('data-suffix')||'',t0=null;
  function st(t){if(!t0)t0=t;var p=Math.min((t-t0)/1500,1);n.textContent=Math.round(to*(1-Math.pow(1-p,3)))+s;if(p<1)requestAnimationFrame(st)}requestAnimationFrame(st)}
var els=d.querySelectorAll('.rv');
if('IntersectionObserver' in window&&!rm){
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting)return;
    e.target.classList.add('in');io.unobserve(e.target);
    e.target.querySelectorAll('[data-count]').forEach(count)})},{threshold:.15});
  els.forEach(function(x){io.observe(x)});
}else{
  els.forEach(function(x){x.classList.add('in')});
  d.querySelectorAll('[data-count]').forEach(function(n){n.textContent=n.getAttribute('data-count')+(n.getAttribute('data-suffix')||'')});
}
var sb=d.querySelector('.sbar'),ord=d.getElementById('order'),inOrd=false;
var up=function(){if(sb)sb.classList.toggle('show',window.scrollY>500&&!inOrd)};
if(sb){
  if(ord&&'IntersectionObserver' in window){new IntersectionObserver(function(es){inOrd=es[0].isIntersecting;up()}).observe(ord)}
  window.addEventListener('scroll',up,{passive:true});up();
}
function galGo(g,i){
  var t=g.querySelectorAll('.gal-t');if(!t.length)return;
  i=(i+t.length)%t.length;
  t.forEach(function(x,k){x.classList.toggle('on',k===i)});
  var im=g.querySelector('.gal-img');im.style.opacity=0;
  setTimeout(function(){im.src=t[i].getAttribute('data-full');im.style.opacity=1},170);
  var c=g.querySelector('.gal-count');if(c)c.textContent=(i+1)+' / '+t.length;
  var box=t[i].parentNode;box.scrollTo({left:t[i].offsetLeft-box.clientWidth/2+t[i].clientWidth/2,behavior:'smooth'});
}
function cur(g){var a=Array.prototype.slice.call(g.querySelectorAll('.gal-t'));return a.findIndex(function(x){return x.classList.contains('on')})}
d.addEventListener('click',function(e){
  var t=e.target.closest('.gal-t');
  if(t){var g=t.closest('.gal');galGo(g,Array.prototype.indexOf.call(g.querySelectorAll('.gal-t'),t));return}
  var a=e.target.closest('.gal-a');
  if(a){var g2=a.closest('.gal');galGo(g2,cur(g2)+(a.classList.contains('next')?1:-1));return}
  var b=e.target.closest('[data-buynow]');
  if(b){e.preventDefault();var f=b.closest('form');
    fetch('/cart/add.js',{method:'POST',body:new FormData(f)}).then(function(){location.href='/checkout'}).catch(function(){f.submit()})}
});
d.addEventListener('change',function(e){
  if(!e.target.matches('.pack input'))return;
  var f=e.target.closest('form');
  f.querySelectorAll('.pack').forEach(function(p){p.classList.toggle('on',p.querySelector('input').checked)});
  var q=f.querySelector('[name=quantity]'),idf=f.querySelector('[name=id]');
  if(e.target.getAttribute('data-variant')){if(idf)idf.value=e.target.value;if(q)q.value=1}
  else if(q){q.value=e.target.value}
});
d.querySelectorAll('.gal-main').forEach(function(m){var x0=null,g=m.closest('.gal');
  m.addEventListener('touchstart',function(e){x0=e.touches[0].clientX},{passive:true});
  m.addEventListener('touchend',function(e){if(x0===null)return;var dx=e.changedTouches[0].clientX-x0;if(Math.abs(dx)>40)galGo(g,cur(g)+(dx<0?1:-1));x0=null});
});
})();
